import {LEVEL_PROGRESS_LIGHT_GREEN_COLOR} from '@utils';

const INVASION_PROGRESS_DARK_GREEN_COLOR = '#047857';

const generateInvasionBarColor = (complete: number) => {
    if (complete < 50) {
        return LEVEL_PROGRESS_LIGHT_GREEN_COLOR;
    }

    return INVASION_PROGRESS_DARK_GREEN_COLOR;
};

export default generateInvasionBarColor;
